import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { App } from "antd";
import { positionsService } from "../services/positions.service";
import type { ListPositionsParams, PositionCreateRequest, PositionUpdateRequest } from "../types";

const QUERY_KEY = "positions";

export function usePositionsList(params: ListPositionsParams) {
	return useQuery({
		queryKey: [QUERY_KEY, params],
		queryFn: () => positionsService.list(params),
		placeholderData: (previous) => previous,
	});
}

export function useCreatePosition() {
	const queryClient = useQueryClient();
	const { message } = App.useApp();

	return useMutation({
		mutationFn: (data: PositionCreateRequest) => positionsService.create(data),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
			message.success("Lavozim qo'shildi");
		},
		onError: () => {
			message.error("Lavozimni qo'shib bo'lmadi");
		},
	});
}

export function useUpdatePosition() {
	const queryClient = useQueryClient();
	const { message } = App.useApp();

	return useMutation({
		mutationFn: ({ id, data }: { id: string; data: PositionUpdateRequest }) =>
			positionsService.update(id, data),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
			message.success("Lavozim saqlandi");
		},
		onError: () => {
			message.error("Lavozimni saqlab bo'lmadi");
		},
	});
}

export function useDeletePosition() {
	const queryClient = useQueryClient();
	const { message } = App.useApp();

	return useMutation({
		mutationFn: (id: string) => positionsService.remove(id),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
			message.success("Lavozim o'chirildi");
		},
		onError: () => {
			message.error("Lavozimni o'chirib bo'lmadi");
		},
	});
}
